import './smInfoContainer.scss';

type SmInfoContainerProps = {
  children: React.JSX.Element | React.JSX.Element[];
  title: string;
  icon: React.JSX.Element;
};

export const SmInfoContainer = ({
  children,
  title,
  icon,
}: SmInfoContainerProps) => {
  return (
    <div data-testid="sm-info-container" className="sm-info-container">
      <div
        data-testid="sm-info-container-title"
        className="sm-info-container-title"
      >
        <span>{icon}</span>
        <span className="sm-info-title">{title}</span>
      </div>
      {children}
    </div>
  );
};
